/**
 * file-readable — geteilte stale-File-Probe für alle XHR-Upload-Engines
 * (UploadProvider = Asset-Upload, use-transfer-upload = Transfer). SSOT, damit
 * die beiden Engines nicht auseinanderdriften (Prod-Vorfall 2026-07-15).
 */

export const FILE_CHANGED_MESSAGE =
  'Datei wurde seit der Auswahl geändert oder ist nicht mehr lesbar — bitte entfernen und neu auswählen.';

/**
 * Chrome liest die Datei beim Senden erneut vom Datenträger; wurde sie seit der
 * Auswahl geändert/ersetzt/verschoben (z.B. durch einen Sync-Client wie Dropbox:
 * atomic-replace ändert den mtime-Snapshot), bricht der Browser den Body
 * mid-flight ab. Der Server sieht dann einen truncated Multipart (400, busboy
 * "Unexpected end of form"), das XHR nur `onerror` (status 0 → „Netzwerkfehler"),
 * und die transiente Retry-Ladder re-sendet dasselbe stale File-Objekt
 * deterministisch erfolglos (Prod-Vorfall 2026-07-15 auf der Transfer-Seite;
 * dieselbe Klasse gilt für den Asset-Upload). Die 1-Byte-Probe erkennt das VOR
 * jedem Versuch (NotReadableError) → terminaler, actionabler Fehler statt drei
 * tote Retries.
 */
export async function isFileReadable(file: File): Promise<boolean> {
  try {
    await file.slice(0, 1).arrayBuffer();
    return true;
  } catch {
    return false;
  }
}
